module.exports = __webpack_public_path__ + "img/image-anousheh-ansari.a342d00e.png";